import { AwarenessReportDatatable } from '@/components/reports/datatables';
import React from 'react';

export const AwarenessReportsPage: React.FC = () => {
  return <AwarenessReportDatatable />;
};
